module.exports = __webpack_public_path__ + "fonts/e48c121.ttf";